// @flow

import { observable, action, computed } from 'mobx';

export class UIStateStore {
    @observable emails: any = [];
    @observable ids: Array<string> = [];
    @observable showMeetingRoom: boolean = false;
    @observable showOtherResource: boolean = false;
    @observable selectedContactEmail: any = null;
    @observable isAdmin: boolean = false;
    @observable adminMode: boolean = false;
    @observable activeView: string = '';
    @observable contactEmails: any;
    @observable contactIds: Array<string>;
    @observable meetingRoomEmails: Array<string>;
    @observable meetingRoomIds: Array<string>;
    @observable otherResourcesEmails: Array<string>;
    @observable otherResourcesIds: Array<string>;
    @observable events: Array<MeetingEvent> = [];
    // Resources select all check box state
    @observable isAllSelected: boolean = false;

    @action setEmails = (emails: Array<String> | string) => {
      let emailsCopy;
      emails.length === 0 ? emailsCopy = [null] : emailsCopy = emails;
      this.emails = emailsCopy;
    }

    @action setShowMeetingRoom = (showMeetingRoom: boolean) => {
      this.showMeetingRoom = showMeetingRoom;
    }

    @action setShowOtherResource = (showOtherResource: boolean) => {
      this.showOtherResource = showOtherResource;
    }

    @action setSelectedContactEmail = (email: string) => {
      this.selectedContactEmail = email;
    }

    @action setIsAdmin = (premission: string) => {
      this.isAdmin = premission === 'CLASSIFY_RESOURCE';
    }

    @action setAdminMode = (flag: boolean) => {
      this.adminMode = flag;
    }
  /**
  * showNotification: show toast notification
  * @method showNotification
  * @param {htmlEelement} notificationRef - notification element reference
  * @param {String} message - notification message
  * @param {String} level - notification level success, error, warning and info
  * @param {String} position - notification position on screen  tr (top right), tl (top left), tc (top center), br (bottom right), bl (bottom left), bc (bottom center)
  * @param {number} autoDismiss - Time of notification showing on the screen
  */
  showNotification = (notificationRef: any, message: string, level: string, position: string, autoDismiss: number) => {
    notificationRef.addNotification({
      message,
      level,
      position,
      autoDismiss,
    });
  }

  // $FlowFixMe
  @computed get getNewEvents() {
    return this.events;
  }

}

export const uiStateStoreInstance = new UIStateStore();



// WEBPACK FOOTER //
// ./src/js/Stores/UIStateStore.js